<div class="gpt-five-mini-dialog">
  <!-- Close (X) -->
  <button class="close-btn" mat-icon-button (click)="close()" aria-label="Close ChatGPT 5 mini Info">
    <span aria-hidden="true">×</span>
  </button>

  <div class="header">
    <img src="assets/logos/openai.svg" alt="ChatGPT 5 mini Logo" class="logo" />
    <h2>ChatGPT 5 mini</h2>
    <div class="sub">
      Fast, reliable everyday intelligence • Great writing + reasoning • Cost-efficient at scale
    </div>
  </div>

  <div class="body">
    <p>
      <strong>ChatGPT 5 mini</strong> is a high-speed, high-quality model designed for
      <strong>production chat</strong>, <strong>business workflows</strong>, and <strong>everyday problem-solving</strong>.
      It’s built to feel smart and helpful while staying lightweight—making it ideal when you want
      <strong>great answers quickly</strong>, <strong>stable formatting</strong>, and <strong>consistent tone</strong>.
      <br /><br />
      Think of it as the “best default” for most users: strong reasoning for common tasks,
      strong writing, and predictable results—without the heavier latency and compute of flagship-tier models.
    </p>

    <ul>
      <li>⚡ <strong>Fast & Responsive:</strong> Optimized for low latency—excellent for live chat and real-time assistance.</li>
      <li>🧠 <strong>Solid Reasoning:</strong> Great at structured thinking, step-by-step explanations, and clear conclusions.</li>
      <li>✍️ <strong>Excellent Writing:</strong> Clean, natural tone for emails, proposals, summaries, and internal docs.</li>
      <li>🧾 <strong>Structured Outputs:</strong> Reliable formatting for lists, templates, bullet summaries, and JSON-style extraction.</li>
      <li>🧰 <strong>Workflow Friendly:</strong> Strong for multi-step tasks like “summarize → extract → decide → draft response”.</li>
      <li>🔒 <strong>Business Safe Defaults:</strong> Designed to be consistent and safe for user-facing applications.</li>
    </ul>

    <div class="optimal">
      <h3>What ChatGPT 5 mini is best at</h3>
      <ul>
        <li>Customer support: fast, helpful answers with stable tone and formatting</li>
        <li>Writing: emails, sales copy, HR notes, proposals, product blurbs, meeting summaries</li>
        <li>Knowledge work: summaries, Q&A, research synthesis, “explain it like I’m busy” outputs</li>
        <li>Everyday reasoning: planning, tradeoffs, checklists, prioritization, decision support</li>
        <li>Extraction + transformation: convert content into bullet points, tables, or structured fields</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>When to choose 5 mini vs bigger models</h3>
      <ul>
        <li><strong>Choose 5 mini</strong> when speed, cost-efficiency, and strong general quality matter most.</li>
        <li><strong>Choose a flagship model</strong> when you need the deepest reasoning, hardest math, or very complex multi-step logic.</li>
        <li><strong>Choose a specialist model</strong> when the task is highly domain-specific (e.g., heavy codebase refactors, long-context legal review).</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Recommended production usage pattern</h3>
      <ul>
        <li>Use <strong>ChatGPT 5 mini</strong> as your default for chat, drafting, and routine workflows</li>
        <li>Require <strong>structured formatting</strong> (bullets, templates, JSON) for app reliability</li>
        <li>Add a <strong>validation pass</strong> for critical workflows (rules, schema checks, citations if needed)</li>
        <li>Escalate to deeper models only for complex edge cases and high-stakes decisions</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Where it shines the most</h3>
      <ul>
        <li>🧑‍💼 <strong>Business operations:</strong> internal workflows, SOP drafts, ticket responses, escalation summaries</li>
        <li>📈 <strong>Productivity:</strong> planning your week, turning notes into action lists, quick analysis</li>
        <li>🧾 <strong>Information shaping:</strong> “make this clearer”, “rewrite for tone”, “summarize into bullets”</li>
        <li>🧠 <strong>Practical reasoning:</strong> recommendations with tradeoffs, constraints, and next steps</li>
        <li>💬 <strong>Conversation:</strong> friendly, consistent dialogue that feels natural and helpful</li>
      </ul>
    </div>
  </div>
</div>
